export const WIDGET_LIMITS = {
  MAX_GROUP_WIDGETS: 10,
  DEFAULT_MAX_WIDGETS: 8,
} as const;
